var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [
            _vm._v("Selección Proveedor Gasto de Representación")
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Fecha Solicitud *" } },
                  [
                    _c("date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        "input-class": {
                          "mx-input": true,
                          "border-danger": _vm.errors.has(
                            "custom-document.requestDate"
                          )
                        },
                        "data-cy": "request-date",
                        name: "requestDate",
                        format: "DD-MM-YYYY",
                        "value-type": "YYYY-MM-DD",
                        "data-vv-as": "fecha solicitud",
                        danger: _vm.errors.has("custom-document.requestDate"),
                        "danger-text": _vm.errors.first(
                          "custom-document.requestDate"
                        )
                      },
                      model: {
                        value: _vm.formData.requestDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "requestDate", $$v)
                        },
                        expression: "formData.requestDate"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "requestDate",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Actividad *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has("custom-document.activity")
                          ? false
                          : null,
                        "data-cy": "activity",
                        "data-vv-as": "actividad",
                        name: "activity",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.activity,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "activity", $$v)
                        },
                        expression: "formData.activity"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "activity",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("h4", [_vm._v("Departamento Administrativo")]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("b-table", {
                  attrs: {
                    responsive: "",
                    striped: "",
                    hover: "",
                    small: "",
                    items: _vm.formData.quotes,
                    fields: _vm.quotesFormFields
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(actions)",
                      fn: function(row) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "flex items-center justify-content-center",
                              attrs: { id: "delete-row-" + row.index }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-block",
                                  attrs: {
                                    size: "sm",
                                    variant: "danger",
                                    disabled: _vm.formData.quotes.length <= 3,
                                    "data-cy": "delete-row-" + row.index
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteQuotesRow(row.index)
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "TrashIcon" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.quotes.length <= 3
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: { target: "delete-row-" + row.index }
                                },
                                [_vm._v(" El mínimo de cotizaciones es 3 ")]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "cell(name)",
                      fn: function(row) {
                        return [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              "data-vv-name": "quotes[" + row.index + "].name",
                              state: _vm.errors.has(
                                "custom-document.quotes[" + row.index + "].name"
                              )
                                ? false
                                : null,
                              name: "quoteName",
                              "data-cy": "quote-name-" + row.index,
                              "data-vv-as": "nombre cotización"
                            },
                            model: {
                              value: row.item.name,
                              callback: function($$v) {
                                _vm.$set(row.item, "name", $$v)
                              },
                              expression: "row.item.name"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(documentType)",
                      fn: function(row) {
                        return [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              name: "documentType",
                              "data-vv-name":
                                "quotes[" + row.index + "].documentType",
                              state: _vm.errors.has(
                                "custom-document.quotes[" +
                                  row.index +
                                  "].documentType"
                              )
                                ? false
                                : null,
                              "data-cy": "document-type-" + row.index,
                              "data-vv-as": "tipo documento tributario"
                            },
                            model: {
                              value: row.item.documentType,
                              callback: function($$v) {
                                _vm.$set(row.item, "documentType", $$v)
                              },
                              expression: "row.item.documentType"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(providerName)",
                      fn: function(row) {
                        return [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              name: "providerName",
                              "data-cy": "provider-name-" + row.index,
                              "data-vv-as": "nombre proveedor",
                              "data-vv-name":
                                "quotes[" + row.index + "].providerName",
                              state: _vm.errors.has(
                                "custom-document.quotes[" +
                                  row.index +
                                  "].providerName"
                              )
                                ? false
                                : null
                            },
                            model: {
                              value: row.item.providerName,
                              callback: function($$v) {
                                _vm.$set(row.item, "providerName", $$v)
                              },
                              expression: "row.item.providerName"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(rut)",
                      fn: function(row) {
                        return [
                          _c("b-form-input-rut", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|validateRut",
                                expression: "'required|validateRut'"
                              }
                            ],
                            attrs: {
                              "data-cy": "quote-rut-" + row.index,
                              "data-vv-name": "quotes[" + row.index + "].rut",
                              danger: _vm.errors.has(
                                "custom-document.quotes[" + row.index + "].rut"
                              ),
                              "danger-text": _vm.errors.first(
                                "custom-document.quotes[" + row.index + "].rut"
                              ),
                              state: _vm.errors.has(
                                "custom-document.quotes[" + row.index + "].rut"
                              )
                                ? false
                                : null,
                              placeholder: "12345678-1"
                            },
                            model: {
                              value: row.item.rut,
                              callback: function($$v) {
                                _vm.$set(row.item, "rut", $$v)
                              },
                              expression: "row.item.rut"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(amount)",
                      fn: function(row) {
                        return [
                          _c("InputCurrency", {
                            attrs: {
                              label: "",
                              options: {
                                locale: "es-CL",
                                currency: "CLP",
                                hideGroupingSeparatorOnFocus: false,
                                currencyDisplay: "hidden",
                                precision: {
                                  min: 0,
                                  max: 2
                                }
                              },
                              id: "quoteAmount",
                              name: "quoteAmount",
                              "data-cy": "quote-amount-" + row.index,
                              state: _vm.errors.has(
                                "custom-document.quotes[" +
                                  row.index +
                                  "].quoteAmount"
                              )
                                ? false
                                : null,
                              danger: _vm.errors.has(
                                "custom-document.quotes[" +
                                  row.index +
                                  "].quoteAmount"
                              ),
                              "data-vv-as": "monto"
                            },
                            on: {
                              input: function($event) {
                                return _vm.validateCurrency(
                                  $event,
                                  "monto",
                                  "custom-document",
                                  "quotes[" + row.index + "].quoteAmount"
                                )
                              }
                            },
                            model: {
                              value: row.item.amount,
                              callback: function($$v) {
                                _vm.$set(row.item, "amount", $$v)
                              },
                              expression: "row.item.amount"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(compliesEETT)",
                      fn: function(row) {
                        return [
                          _c("b-form-checkbox", {
                            attrs: {
                              "data-cy": "quote-complies-eett-" + row.index,
                              switch: ""
                            },
                            model: {
                              value: row.item.compliesEETT,
                              callback: function($$v) {
                                _vm.$set(row.item, "compliesEETT", $$v)
                              },
                              expression: "row.item.compliesEETT"
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "cell(attachedQuote)",
                      fn: function(row) {
                        return [
                          !row.item.attachedQuotes.length ||
                          !row.item.attachedQuotes[0].id
                            ? _c("select-doc-from", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  "data-cy": "select-doc-from-" + row.index,
                                  "modal-name": "select-doc-from-" + row.index,
                                  id: row.index,
                                  "max-files": 1,
                                  files: row.item.attachedQuotes,
                                  "add-file": function(file) {
                                    _vm.addQuoteFile(file, row.item)
                                    row.item.attachedQuote = file
                                  },
                                  "remove-file": function(id) {
                                    _vm.removeQuoteFile(id, row.item)
                                    row.item.attachedQuote = {}
                                    row.item.attachedQuotes = []
                                  },
                                  "data-vv-name":
                                    "quotes[" + row.index + "].attachedQuote",
                                  danger: _vm.errors.has(
                                    "custom-document.quotes[" +
                                      row.index +
                                      "].attachedQuote"
                                  )
                                },
                                model: {
                                  value: row.item.attachedQuotes[0],
                                  callback: function($$v) {
                                    _vm.$set(row.item.attachedQuotes, 0, $$v)
                                  },
                                  expression: "row.item.attachedQuotes[0]"
                                }
                              })
                            : _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("vs-icon", {
                                    attrs: {
                                      icon: "description",
                                      size: "25px",
                                      color: "primary"
                                    }
                                  }),
                                  _c(
                                    "b",
                                    {
                                      staticClass:
                                        "text-truncate w-32 text-center"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(row.item.attachedQuotes[0].name)
                                      )
                                    ]
                                  ),
                                  _c("vs-button", {
                                    attrs: {
                                      "data-cy":
                                        "remove-annex-file-" + row.index,
                                      color: "danger",
                                      type: "flat",
                                      icon: "clear"
                                    },
                                    on: {
                                      click: function() {
                                        row.item.attachedQuotes = []
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm.errors.has(
                            "custom-document.quotes[" +
                              row.index +
                              "].attachedQuote"
                          )
                            ? _c("div", [
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("Debe adjuntar un documento")
                                ])
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("ValidationError", {
                  attrs: {
                    document: "custom-document",
                    "custom-error":
                      "Debe ingresar todos los datos solicitados en la tabla",
                    "validation-array": _vm.formData.quotes
                      .map(function(_, index) {
                        return [
                          "quotes[" + index + "].name",
                          "quotes[" + index + "].documentType",
                          "quotes[" + index + "].providerName",
                          "quotes[" + index + "].rut"
                        ]
                      })
                      .flat(),
                    "validator-errors": _vm.errors
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "-mt-2 float-right",
                    attrs: { variant: "primary", "data-cy": "add-row" },
                    on: { click: _vm.addQuotesRow }
                  },
                  [_vm._v(" Agregar Fila ")]
                )
              ],
              1
            )
          ]),
          _c("h4", [_vm._v("Selección del Proveedor")]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-4" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mt-0 mt-md-8",
                    attrs: { label: "Selección *" }
                  },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "m-0",
                        attrs: {
                          name: "providerSelection",
                          "data-cy": "provider-selection",
                          "data-vv-as": "seleccion de proveedor",
                          switch: ""
                        },
                        model: {
                          value: _vm.formData.providerSelection,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "providerSelection", $$v)
                          },
                          expression: "formData.providerSelection"
                        }
                      },
                      [_vm._v(" Menor precio ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-8" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Fundamentación de Selección *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        state: _vm.errors.has(
                          "custom-document.selectionJustification"
                        )
                          ? false
                          : null,
                        "data-cy": "selection-justification",
                        "data-vv-as": "fundamentación de selección",
                        name: "selectionJustification",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.selectionJustification,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "selectionJustification", $$v)
                        },
                        expression: "formData.selectionJustification"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "selectionJustification",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Proveedor Seleccionado *" } },
                  [
                    _c(
                      "b-form-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "data-cy": "selected-provider",
                          name: "selectedProvider",
                          "data-vv-as": "proveedor seleccionado",
                          state: _vm.errors.has(
                            "custom-document.selectedProvider"
                          )
                            ? false
                            : null
                        },
                        model: {
                          value: _vm.formData.selectedProvider,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "selectedProvider", $$v)
                          },
                          expression: "formData.selectedProvider"
                        }
                      },
                      [
                        _vm.invalidProvidersName
                          ? _c("option", { domProps: { value: null } }, [
                              _vm._v(
                                " -- Debes ingresar un proveedor en la tabla -- "
                              )
                            ])
                          : _c(
                              "option",
                              {
                                attrs: { disabled: "" },
                                domProps: { value: null }
                              },
                              [_vm._v(" -- Selecciona un proveedor -- ")]
                            ),
                        _vm._l(_vm.formQuotesWithProvider, function(option) {
                          return _c(
                            "option",
                            {
                              key: option.providerName,
                              domProps: { value: option }
                            },
                            [_vm._v(" " + _vm._s(option.providerName) + " ")]
                          )
                        })
                      ],
                      2
                    ),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "selectedProvider",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Monto *" } },
                  [
                    _c("InputCurrency", {
                      attrs: {
                        label: "",
                        disabled: "",
                        options: {
                          locale: "es-CL",
                          currency: "CLP",
                          hideGroupingSeparatorOnFocus: false,
                          currencyDisplay: "hidden",
                          precision: {
                            min: 0,
                            max: 2
                          }
                        },
                        id: "selectedProviderAmount",
                        name: "selectedProviderAmount",
                        "data-cy": "selectedProviderAmount",
                        state: _vm.errors.has(
                          "custom-document.selectedProviderAmount"
                        )
                          ? false
                          : null,
                        danger: _vm.errors.has(
                          "custom-document.selectedProviderAmount"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.selectedProviderAmount"
                        ),
                        "data-vv-as": "monto"
                      },
                      model: {
                        value: _vm.selectedProviderAmount,
                        callback: function($$v) {
                          _vm.selectedProviderAmount = $$v
                        },
                        expression: "selectedProviderAmount"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "selectedProviderAmount",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("h4", [_vm._v("Datos bancarios")]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "RUT *" } },
                  [
                    _c("b-form-input-rut", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|validateRut",
                          expression: "'required|validateRut'"
                        }
                      ],
                      attrs: {
                        id: "bankRut",
                        name: "bankRut",
                        "data-cy": "bank-rut",
                        "data-vv-as": "rut",
                        danger: _vm.errors.has("custom-document.bankRut"),
                        "danger-text": _vm.errors.first(
                          "custom-document.bankRut"
                        ),
                        state: _vm.errors.has("custom-document.bankRut")
                          ? false
                          : null,
                        placeholder: "12345678-1"
                      },
                      model: {
                        value: _vm.formData.bank.rut,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.bank, "rut", $$v)
                        },
                        expression: "formData.bank.rut"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "bankRut",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Correo *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email|max:80",
                          expression: "'required|email|max:80'"
                        }
                      ],
                      attrs: {
                        "data-vv-as": "correo",
                        id: "bankEmail",
                        name: "bankEmail",
                        "data-cy": "bank-email",
                        placeholder: "Correo",
                        type: "email",
                        state: _vm.errors.has("custom-document.bankEmail")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.formData.bank.email,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.bank, "email", $$v)
                        },
                        expression: "formData.bank.email"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "bankEmail",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-4" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Banco *" } },
                  [
                    _c(
                      "b-form-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          disabled: _vm.loadingBankOptions,
                          "data-cy": "bank-name",
                          name: "bankName",
                          "data-vv-as": "banco",
                          state: _vm.errors.has("custom-document.bankName")
                            ? false
                            : null,
                          options: _vm.bankOptions
                        },
                        model: {
                          value: _vm.formData.bank.name,
                          callback: function($$v) {
                            _vm.$set(_vm.formData.bank, "name", $$v)
                          },
                          expression: "formData.bank.name"
                        }
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null }
                          },
                          [_vm._v(" " + _vm._s(_vm.bankLoadingText) + " ")]
                        )
                      ]
                    ),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "bankName",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-4" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tipo Cuenta *" } },
                  [
                    _c(
                      "b-form-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          "data-vv-as": "tipo cuenta",
                          id: "bankAccountType",
                          name: "bankAccountType",
                          "data-cy": "bank-account-type",
                          state: _vm.errors.has(
                            "custom-document.bankAccountType"
                          )
                            ? false
                            : null,
                          options: _vm.bankAccountTypes
                        },
                        model: {
                          value: _vm.formData.bank.accountType,
                          callback: function($$v) {
                            _vm.$set(_vm.formData.bank, "accountType", $$v)
                          },
                          expression: "formData.bank.accountType"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v("-- Selecciona un tipo de cuenta --")
                        ])
                      ]
                    ),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "bankAccountType",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-4" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "N° Cuenta *" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "data-vv-as": "número de cuenta",
                        type: "number",
                        id: "bankAccountNumber",
                        name: "bankAccountNumber",
                        "data-cy": "bank-account-number",
                        state: _vm.errors.has(
                          "custom-document.bankAccountNumber"
                        )
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.formData.bank.accountNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.formData.bank, "accountNumber", $$v)
                        },
                        expression: "formData.bank.accountNumber"
                      }
                    }),
                    _c("ValidationError", {
                      attrs: {
                        document: "custom-document",
                        validation: "bankAccountNumber",
                        "validator-errors": _vm.errors
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "row align-items-center mt-1" },
            [
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-file-repository",
                          expression: "'add-file-repository'"
                        }
                      ],
                      staticClass: "btn-icon mt-1",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "from-repository"
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                      _vm._v(" Adjuntar archivo desde repositorio ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.files, function(file) {
                return _c("div", { key: file.id, staticClass: "col-2" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "25px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "row justify-end" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "cancel",
                    color: "primary",
                    disabled: _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "save",
                    color: "success",
                    disabled: _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [
                  _vm._v(" Crear "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saving,
                        expression: "saving"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-primary"
                  })
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-file-repository",
          "add-file": _vm.addFileRepo,
          files: _vm.files,
          "remove-file": _vm.removeFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }